if (".in-index".length) {
  var storredNews = sessionStorage.getItem(document.location.hostname + "-storredNewsData");

  if (storredNews) {
    var storredNews = JSON.parse(storredNews);
    $(".blogWrapper .news-wrapper").html(storredNews);
  } else {
    $.ajax({
      url: "/nase-novinky/",
      type: "GET",
      success: function (response) {
        var content = $(response);
        var newsItems = content.find(".news-item").slice(0, 3);
        var combinedHtml = "";
        newsItems.each(function (index, element) {
          var $element = $(element);
          var $elementImage = $element.find(".image img").attr("data-src") || $element.find(".image img").attr("src");
          var $elementTitle = $element.find(".title").text().trim();
          var $elementCreated = $element.find("time").text().trim();
          var $elementLink = $element.find(".title").attr("href");
          var $elementDescription = $element.find(".description").html();
          combinedHtml += `
                    <div class="news-item">
                        <div class="image">
                            <a href="${$elementLink}" class="title">
                                <img src="${$elementImage}">
                            </a>
                        </div>
                        <a href="${$elementLink}" class="text">
                            <span class="created ts">${$elementCreated}</span>
                        
                            <span class="tms title">${$elementTitle}</span>
                            <span class="description tm">${$elementDescription}</span>
                        </a>
                    </div>
                `;
        });
        $(".blogWrapper .news-wrapper").html(combinedHtml);
        sessionStorage.setItem(document.location.hostname + "-storredNewsData", JSON.stringify(combinedHtml));
      },
      error: function (xhr, status, error) {
        console.error("Error fetching news data:", status, error);
      },
    }).done(function () {});
  }
}
